export default function lowerCaseFilter(s) {
  if (typeof s !== 'string') {
    return s;
  }

  return s.toLowerCase();
}
